import { render, staticRenderFns } from "./scsc.vue?vue&type=template&id=5f817094&scoped=true&"
import script from "./scsc.vue?vue&type=script&lang=js&"
export * from "./scsc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f817094",
  null
  
)

export default component.exports